import React from 'react';

import { CheckmarkOutline } from '@lyearn/icons';
import { AutocompleteRenderOptionState, Stack } from '@lyearn/ui';
import * as User from '@/components/User';
import { UserFragment } from '@/graphql/fragments/generated/User';

import { ReportRecipientType } from './types';

// can move these to entity if more usages occur
export const renderAddUsersOption = (
  recipient: UserFragment | string,
  state: AutocompleteRenderOptionState,
) => {
  const user = typeof recipient === 'string' ? { name: recipient } : recipient;

  return (
    <Stack alignItems="center" className="w-full p-12" gapX={8} justifyContent="between">
      <User.Provider alignItems="center" className="flex items-center space-s-12" user={user}>
        <User.ProfilePicture size="large" />
        <Stack direction="col">
          <User.Name />
          <User.UniqueId />
        </Stack>
      </User.Provider>
      {state.selected ? (
        <CheckmarkOutline className="h-20 w-20 flex-shrink-0" fillColorToken="icon-primary" />
      ) : null}
    </Stack>
  );
};

export const getUserOptionLabel = (option: string | UserFragment) =>
  typeof option === 'string' ? option : option.name || option.uniqueId;

export const isUserOptionEqualToValue = (
  option: ReportRecipientType,
  value: ReportRecipientType,
) => {
  const optionLabel = typeof option === 'string' ? option : option.uniqueId;
  const valueLabel = typeof value === 'string' ? value : value.uniqueId;

  return optionLabel === valueLabel;
};
